module.exports = __webpack_public_path__ + "images/FUSA_icons/015-barcode.b1ffaad81979500924f5f75cb70c4986.svg";